// removed by extract-text-webpack-plugin
module.exports = {"header":"HoverTooltip__header"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HoverTooltip/HoverTooltip.scss
// module id = ./src/components/HoverTooltip/HoverTooltip.scss
// module chunks = 2